import { render, staticRenderFns } from "./BannerPart.vue?vue&type=template&id=3bc24915&scoped=true"
import script from "./BannerPart.vue?vue&type=script&lang=js"
export * from "./BannerPart.vue?vue&type=script&lang=js"
import style0 from "./BannerPart.vue?vue&type=style&index=0&id=3bc24915&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc24915",
  null
  
)

export default component.exports